let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        name: '王汇丰' + (i + 1),
        no: 'yf' + Date.now(),
        companyName: '  ',
        companyId: 'yfds01',
        deptName: '研发部',
        deptId: 'yfb01',
        mobile: '18888888888'
    });
}

export default list;



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/customer/queryByName.js